import { calculateNoticePeriod } from '../noticePeriodCalculator.js';

function formatDate(date) {
    return date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
}

function calculate() {
    const startDate = document.getElementById('startDate').value;
    const noticeDays = parseInt(document.getElementById('noticeDays').value) || 0;

    const result = calculateNoticePeriod(startDate, noticeDays);
    if (!result) {
        document.getElementById('results').innerHTML = '<p style="color: #dc2626;">Please enter a valid start date and notice period.</p>';
        return;
    }

    const statusBadge = result.isComplete
        ? '<span style="background:#dcfce7;color:#166534;padding:0.25rem 0.75rem;border-radius:9999px;font-size:0.75rem;font-weight:700;">✓ Notice Complete</span>'
        : `<span style="background:#fef3c7;color:#92400e;padding:0.25rem 0.75rem;border-radius:9999px;font-size:0.75rem;font-weight:700;">${result.daysRemaining} days remaining</span>`;

    document.getElementById('results').innerHTML = `
        <div class="result-card">
            <p style="margin:0;font-size:0.875rem;text-transform:uppercase;font-weight:600;color:#4f46e5;letter-spacing:0.05em;">Last Working Day</p>
            <h2 class="result-total" style="font-size:1.75rem;">${formatDate(result.lastWorkingDay)}</h2>
            <div style="margin-top:1rem;">${statusBadge}</div>
        </div>

        <table class="results-table">
            <tr><th>Detail</th><th>Value</th></tr>
            <tr><td>Notice Start Date</td><td>${formatDate(result.startDate)}</td></tr>
            <tr><td>Total Calendar Days</td><td>${result.calendarDays}</td></tr>
            <tr><td>Working Days (Mon–Fri)</td><td>${result.workingDays}</td></tr>
            <tr><td>Duration</td><td>${result.weeks} weeks ${result.remainderDays > 0 ? '+ ' + result.remainderDays + ' days' : ''}</td></tr>
            ${!result.isComplete ? `<tr><td>Working Days Remaining</td><td><strong>${result.workingDaysRemaining}</strong></td></tr>` : ''}
        </table>
    `;
}

document.getElementById('calculateBtn').addEventListener('click', calculate);

// Common notice periods quick-fill
document.querySelectorAll('.quick-fill').forEach(btn => {
    btn.addEventListener('click', () => {
        document.getElementById('noticeDays').value = btn.getAttribute('data-days');
        calculate();
    });
});
